<template>
    <div class="company-information-form">
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.country_label')"
            :required="true"
            orientation="horizontal"
        >
            <CompassSelect v-model="selectedCountry" :filterable="true">
                <CompassDropdownSelectOption
                    v-for="item in countries"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                    :flag="item.code.toLowerCase()"
                    type="flag"
                />
            </CompassSelect>
        </CompassFormItem>
        <SirenSearchBar v-if="showSirenSearchBar" @select="handleResultSelected" />
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.siren_label')"
            :required="true"
            orientation="horizontal"
        >
            <CompassInput v-model="siren" />
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.siret_label')"
            :required="true"
            orientation="horizontal"
        >
            <CompassInput v-model="siret" />
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.company_name_label')"
            :required="true"
            orientation="horizontal"
        >
            <CompassInput v-model="companyName" />
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.vat_number_label')"
            :required="true"
            orientation="horizontal"
        >
            <CompassInput v-model="vatNumber" :disabled="isVatExempt" />
            <CompassCheckbox
                :modelValue="false"
                :checked="isVatExempt"
                :label="$t.__('CompanyInformation.legal_information.vat_exempt_label')"
                class="company-information-form__vat-exempt-checkbox"
                @change="handleTaxExemptionChange"
            />
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.legal_status_label')"
            orientation="horizontal"
        >
            <CompassSelect v-model="legalStatus">
                <CompassDropdownSelectOption
                    v-for="item in companyLegalStatusList"
                    :key="item"
                    :label="item"
                    :value="item"
                />
            </CompassSelect>
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.share_capital_label')"
            orientation="horizontal"
        >
            <CompassInput v-model="shareCapital">
                <template v-if="showCurrencyLeft" #prefix>
                    {{ numformat.currencysymbol }}
                </template>
                <template v-if="showCurrencyRight" #suffix>
                    {{ numformat.currencysymbol }}
                </template>
            </CompassInput>
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.naf_code_label')"
            orientation="horizontal"
        >
            <CompassInput v-model="naf" />
        </CompassFormItem>
        <CompassFormItem
            :label="$t.__('CompanyInformation.legal_information.rcs_label')"
            orientation="horizontal"
        >
            <CompassInput v-model="rcs" />
        </CompassFormItem>
        <CompassButton
            class="company-information-form__save-button"
            :label="$t.__('CompanyInformation.legal_information.save_button')"
        />
    </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import SirenSearchBar from 'vcomponents/common/SirenSearchBar/SirenSearchBar.vue';
const { mapState: corpMapState } = createNamespacedHelpers('corp');
const { mapGetters: systemMapGetters } = createNamespacedHelpers('system');

export default {
    components: {
        SirenSearchBar,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        countries: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selectedCountry: 'FR',
            siren: this.data.legal_france.siren || '',
            siret: this.data.legal_france.siret || '',
            companyName: this.data.legal_france.company_name || '',
            vatNumber: this.data.legal_france.vat || '',
            isVatExempt: false,
            legalStatus: this.data.legal_france.company_type || '',
            shareCapital: this.data.capital || '',
            naf: this.data.legal_france.ape_naf_code || '',
            rcs: this.data.legal_france.rcs_immatriculation || '',
        };
    },
    computed: {
        ...corpMapState(['numformat']),
        ...systemMapGetters({
            companyLegalStatusList: 'getCompanyLegalStatusList',
        }),
        showCurrencyLeft() {
            return this.numformat.currencypos === 'left' || this.numformat.currencypos === 'both';
        },
        showCurrencyRight() {
            return this.numformat.currencypos === 'right' || this.numformat.currencypos === 'both';
        },
        showSirenSearchBar() {
            return ['FR', 'GP', 'MQ', 'RE'].includes(this.selectedCountry);
        },
    },
    methods: {
        handleTaxExemptionChange(value) {
            this.isVatExempt = value;
            if (value) {
                this.vatNumber = '';
            }
        },
        handleResultSelected(result) {
            this.siren = result.id;
            this.siret = result.siret;
            this.companyName = result.name;
            this.naf = result.job_code;
        },
    },
};
</script>
<style lang="scss" scoped>
.company-information-form {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);

    &__vat-exempt-checkbox {
        margin-top: var(--spacing-0);
    }

    &__save-button {
        display: block;
        margin-left: auto;
    }
}
</style>
